/**
 * Chromia Blockchain Configuration
 * 
 * Configure these values in your .env file:
 * - VITE_BLOCKCHAIN_URL: Node URL(s) - can be a JSON array or single URL
 * - VITE_ECONOMY_CHAIN_BRID: Economy chain blockchain RID
 * - VITE_VAULT_URL: Chromia Vault URL
 * - VITE_ADMIN_ACCOUNT_ID: Admin FT4 account ID that receives entry fees
 * - VITE_CHR_ASSET_ID: CHR token asset ID on economy chain
 */

const parseBlockchainUrls = (url) => {
    const urls = (() => {
        try {
            return JSON.parse(url);
        } catch {
            return url;
        }
    })();

    if (typeof urls === "string") {
        return [urls];
    }

    if (Array.isArray(urls)) {
        return urls.filter(Boolean);
    }

    const msg = "Blockchain URL is not configured. Please verify app configuration";
    if (typeof window === "object") {
        alert(msg);
    }
    throw new Error(msg);
};

export const blockchainUrls = parseBlockchainUrls(
    import.meta.env.VITE_BLOCKCHAIN_URL || "http://localhost:7740"
);

export const ecBrid = import.meta.env.VITE_ECONOMY_CHAIN_BRID || "";
export const vaultUrl = import.meta.env.VITE_VAULT_URL || "";

// Log configuration in development
if (import.meta.env.DEV) {
    console.info("blockchainUrls", blockchainUrls);
    console.info("ecBrid", ecBrid);
    console.info("vaultUrl", vaultUrl);
}

// Validation - only warn in development, don't throw to allow app to load
const validateConfig = () => {
    const warnings = [];
    
    if (!ecBrid) {
        warnings.push("Economy chain RID (VITE_ECONOMY_CHAIN_BRID) is not configured.");
    }
    
    if (!vaultUrl) {
        warnings.push("Vault URL (VITE_VAULT_URL) is not configured.");
    }
    
    if (warnings.length > 0 && import.meta.env.DEV) {
        console.warn("⚠️ Chromia Configuration Warnings:");
        warnings.forEach(w => console.warn(`  - ${w}`));
        console.warn("Please add these to your .env file for full functionality.");
    }
    
    return warnings.length === 0;
};

export const isConfigValid = validateConfig();

/**
 * Generate client config for postchain-client
 */
export const generateClientConfig = ({ blockchainRid }) => ({
    nodeUrlPool: blockchainUrls,
    blockchainRid,
});
/**
 * Economy chain client config
 */
export const economyChainConfig = generateClientConfig({ blockchainRid: ecBrid });
